import { IUserContext } from '../interfaces/models/iuser-context.model';

/** Админ или модератор хотя бы одной БФ. */
export function canAccessForceCompleteWorkflow(user: IUserContext | null | undefined): boolean {
  if (!user) return false;
  if (user.GlobalAdmin) return true;

  const groupIds = new Set(
    (user.Groups || [])
      .map((g) => g.GroupId ?? g.Group?.Id)
      .filter((id): id is number => !!id)
  );

  return (user.BusinessFunctionContexts || []).some(
    (bf) => !!bf?.ModeratorsGroupId && groupIds.has(bf.ModeratorsGroupId)
  );
}
